import React, {
  useEffect,
  useState,
  useCallback,
} from "react";
import { LoadingSpinner, PageLayout } from "lib";
import { Helmet } from "react-helmet";
import Search from "lib/components/Search/Search";
import { PrimaryButton } from "lib/components/Buttons/buttons";
import AddIcon from "@mui/icons-material/Add";
import { Pagination, Box } from "@mui/material";
import DisplayEvents from "./DisplayEvents";
import FilterEvents from "./FilterEvents";
import AddEvent from "./AddEvent";

import { useUser } from "hooks/useUser";

import { EventsAPI } from "api_inbusiness";

const Events = () => {
  const [events, setEvents] = useState([]);
  const { permissionsData } = useUser();
  const eventsPerPage = 9;

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [loading, setLoading] = useState(true);

  const [openFilter, setOpenFilter] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);

  const [search, setSearch] = useState("");
  const [filterData, setFilterData] = useState({ locationId: "" });

  const [isSearch, setIsSearch] = useState(false);

  const [isFilter, setIsFilter] = useState(false);

  const [triggerRefetch, setTriggerRefetch] = useState(false);
  const [triggerSearch, setTriggerSearch] = useState(false);
  const [triggerFilter, setTriggerFilter] = useState(false);

  const [count, setCount] = useState(0);

  const fetchEvents = useCallback((page = 1) => {
    setLoading(true);
    EventsAPI.get(eventsPerPage, page - 1, 1).then((res) => {
      if (res.ok) {
        setEvents(res.data.content);
        setCount(res.data.count);
        setTotalPages(Math.ceil(res.data.count / eventsPerPage));
        setLoading(false);
      } else {
        setEvents([]);
        setCount(0);
        setTotalPages(1);
        setLoading(false);
      }
    });
  }, []);

  const resetFilter = () => {
    setIsFilter(false);
    setFilterData({ locationId: "" });
  };

  const resetSearch = () => {
    setIsSearch(false);
    setSearch("");
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const searchEvent = () => {
    EventsAPI.searchEvent(search).then((res) => {
      setEvents(res.data);
      setTotalPages(1);
      setCurrentPage(1);
      setLoading(false);
    });
  };

  const getDefaultEvents = () => {
    setCurrentPage(1);
    fetchEvents(1);
  };

  const getInitialEvents = () => {
    fetchEvents(currentPage);
  };

  useEffect(() => {
    if (!isSearch && !isFilter) {
      fetchEvents(currentPage);
    }
  }, [currentPage, fetchEvents, isSearch, isFilter]);

  return (
    <>
      <Helmet>
        <title>InBusiness CRM :: Evenimente</title>
      </Helmet>
      <PageLayout
        title="Evenimente"
        actionArea={
          <>
            <Search
              isFilter={isFilter}
              isSearch={isSearch}
              setIsSearch={setIsSearch}
              search={search}
              setSearch={setSearch}
              nameToFind={"Caută eveniment"}
              triggerRefetch={triggerRefetch}
              setTriggerRefetch={setTriggerRefetch}
              triggerSearch={triggerSearch}
              setTriggerSearch={setTriggerSearch}
              setLoading={setLoading}
              setterFunction={setEvents}
              setIsFilter={setIsFilter}
              resetFilter={resetFilter}
              defaultGet={getDefaultEvents}
              searchGet={searchEvent}
            />

            {permissionsData.seeAdminButtons && (
              <PrimaryButton
                startIcon={<AddIcon />}
                color="primary"
                onClick={() => setOpenAdd(true)}
              >
                ADAUGĂ EVENIMENT
              </PrimaryButton>
            )}
          </>
        }
      >
        <DisplayEvents
          events={events}
          loading={loading}
          getAllEvents={getInitialEvents}
        />
        
        {/* Pagination */}
        {!loading && !isSearch && !isFilter && totalPages > 1 && (
          <Box 
            sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              mt: 4,
              mb: 2,
            }}
          >
            <Pagination 
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              size="large"
              showFirstButton
              showLastButton
              sx={{
                '& .MuiPaginationItem-root': {
                  fontSize: '1rem',
                },
              }}
            />
          </Box>
        )}
      </PageLayout>

      <FilterEvents
        open={openFilter}
        setOpen={setOpenFilter}
        filterData={filterData}
        setFilterData={setFilterData}
        triggerFilter={triggerFilter}
        setTriggerFilter={setTriggerFilter}
        triggerRefetch={triggerRefetch}
        setTriggerRefetch={setTriggerRefetch}
        isFilter={isFilter}
        setIsFilter={setIsFilter}
        setLoading={setLoading}
        setData={setEvents}
        resetSearch={resetSearch}
        resetFilter={resetFilter}
      />

      <AddEvent
        open={openAdd}
        setOpen={setOpenAdd}
        triggerRefetch={triggerRefetch}
        setTriggerRefetch={setTriggerRefetch}
        getAllEvents={getInitialEvents}
      />
    </>
  );
};

export default Events;
